export default "__VITE_ASSET__06221e84__"